export default __webpack_public_path__ + "img/1_11-f160feac.png";